import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "value", "valueTextProps"];
import React from 'react';
import { Box, Text } from 'core/components';
var LabelValue = function LabelValue(_ref) {
  var label = _ref.label,
    value = _ref.value,
    valueTextProps = _ref.valueTextProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    mb: 1
  }, rest), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold"
  }, label), ": ", value && /*#__PURE__*/React.createElement(Text, valueTextProps, value));
};
LabelValue.defaultProps = {
  valueTextProps: {}
};
export default LabelValue;